

import {
    toLakh,
    sumThis,
    numberWithCommas,
    toCurrency,
    sumOf,
    countOf,
    sumAndCountOf,
    showSum,
    showCount,
    showSumAndCount,
    percentChange,
    showBlank,
    changeClassTo,
    mobileNumber,
    panCardNumber,
    validEmail,
    adharNumber,
    allDirectQueries
  } from "../commonFunctions";
  
  const maintainpost = {
    label: "Maintain Post",
    pageLabel: "Maintain Post",
    starting: true,
    url: "maintainpost",
    pageType: "history",
    form: [
        {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Posting Options",
            name: "",
            description: "Enter Posting Options"
          },
          {
            inputType: "select",
            default: "",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            options: [
              {
                label: "Send To self",
                value: "Send To self"
              },
              {
                label: "Send To A Specific Person",
                value: "Send To A Specific Person"
              },
              {
                label: "Send To Branch",
                value: "Send To Branch"
              },
              {
                label: "Send To Entire Branch",
                value: "Send To Entire Branch"
              }
             ],
            placeHolder: "Posting Options",
            name: "PostingOptions",
            description: "Enter Posting Options"
          },
        {
            inputType: "displaytext",
            
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Select Recipient",
            name: "",
            description: "Enter Select Recipient" 
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "Select Recipient",
            name: "SelectRecipient",
            description: "Enter Select Recipient"
          },
          {
            inputType: "displaytext",
            tab: "filterop",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Select Branch",
            name: "",
            description: "Enter Select Branch"
          },
          {
            inputType: "select",
            
            default: "",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            options: [
              {
                label: "All",
                value: "All"
              },
              
             ],
            placeHolder: "Select Branch",
            name: "SelectBranch",
            description: "Enter Select Branch"
          },
          
          
          

         
    ]
  }
  export default maintainpost;